import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const FooterContainer = styled.footer`
  background-color: #000;
`;

export const FooterWrap = styled.div`
  padding: 48px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1100px;
  margin: 0 auto;
`;

export const SocialMedia = styled.section`
  max-width: 1000px;
  width: 100%;
`;

export const SocialMediaWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1100px;
  margin: 40px auto 0 auto;
  @media screen and (max-width: 820px) {
    flex-direction: column;
  }
`;

export const SocialLogo = styled(Link)`
  color: #fff;
  justify-self: start;
  cursor: pointer;
  text-decoration: none;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  margin: 0;
  font-weight: bold;
`;
export const WebsiteRights = styled.small`
  font-size: 12px;
  color: #fff;
  margin: 0;
`;
export const StyledAnchor = styled.a`
  font-size: 16px;
  text-decoration: none;
  color: #fff;
  margin: 0;
`;
export const SocialIcons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SocialIconWrapper = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;

  & + & {
    margin-left: 24px;
  }

  > svg {
    width: 100%;
    height: 100%;
    color: #fff;

    &:hover {
      color: #04d9ff;
    }
  }
`;

export const FooterInfo = styled.div`
  display: flex;
  flex-direction: column;
`;
